export const DIRECTION = {
    PRE: 'PRE', //上一页
    NEXT: 'NEXT' //下一页
}
